import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// @material-ui/icons
import RefreshIcon from '@material-ui/icons/Refresh';

// custom
import Button from "components/react-template/CustomButtons/Button.jsx";
import {
    refreshView as refreshViewAction,
} from 'store/actions/listActions';

/**
 * 새로고침 버튼 
 */
const RefreshButton = ({
    label,
    refreshView,
    buttonProps,
    iconProps,
    children,
    ...rest
}) => (
    <Button {...rest} onClick={refreshView} {...buttonProps} >
        <RefreshIcon {...iconProps}/>{label}
        {children}
    </Button>
);

RefreshButton.propTypes = {
    buttonProps: PropTypes.object,
    iconProps: PropTypes.object,
    label: PropTypes.node,
    refreshView: PropTypes.func.isRequired
};

export default compose(
    connect(
        null, {
            refreshView: refreshViewAction,
        }
    ),
)(RefreshButton);